<template>
  <v-sheet
    color="white"
    class="rounded-lg shadow"
    :class="{
      isFullSizeViewWidth: showFullPanelView,
      isFullSizeViewOverflow: showFullPanelView,
    }"
  >
    <div
      fill-width
      class="ma-0 pa-0"
      :class="{ isFullSizeViewWidth: showFullPanelView }"
    >
      <v-row class="ma-0 pa-0">
        <v-col cols="12" class="ma-0 pa-0">
          <v-container v-if="showTitleBar" fluid fill-width class="ma-0 pa-0">
            <v-row class="ma-0 pa-0">
              <v-col cols="12" class="ma-0 pa-0">
                <v-card color="#eeeeee" class="pt-1">
                  <v-card-title class="primary--text pl-3 py-2"
                    >Pairwise Comparison
                    <v-spacer />
                    <v-chip
                      v-for="(x, index) in [
                        '1',
                        '0.1',
                        '0.05',
                        '0.01',
                        '0.001',
                      ]"
                      :key="`vc-${index}`"
                      :color="colors['pvals'][x + '-' + colorScheme]['color']"
                      :class="
                        colorScheme == 'brewer5' && x == '0.001'
                          ? 'white--text'
                          : ''
                      "
                      >p &lt; {{ x }}</v-chip
                    >
                  </v-card-title>
                  <v-card-subtitle
                    v-if="
                      !outcomeVar || outcomeVar.data_category != 'Categorical'
                    "
                    if
                    cl
                    class="primary--text"
                  >
                    Showing Tukey Range/HSD Test Results
                  </v-card-subtitle>

                  <v-card-subtitle v-else class="primary--text">
                    No pairwise test available
                  </v-card-subtitle>

                  <v-card-title class="primary--text pa-0 pl-3">
                    <v-tooltip v-if="outcomeVar" bottom color="primary">
                      <template v-slot:activator="{ on: tooltip }">
                        <img
                          :src="
                            '/images/' + outcomeVar.category + '-icon-128.png'
                          "
                          :title="outcomeVar.category"
                          style="height:1.75em"
                          class="ma-1"
                          v-on="{ ...tooltip }"
                        />
                      </template>
                      <span>{{ outcomeVar.category }}</span>
                    </v-tooltip>
                    <span v-if="outcomeVar" class="subtitle-1">{{
                      outcomeVar.label
                    }}</span>
                  </v-card-title>
                </v-card>
              </v-col>
            </v-row>
          </v-container>

          <v-container v-else fluid fill-width class="ma-0 pa-0">
            <v-row class="ma-0 pa-0">
              <v-col cols="12" class="ma-0 pa-0">
                <v-container fluid fill-width class="ma-0 pa-0">
                  <v-row class="ma-0 pa-0">
                    <v-col cols="12" class="ma-0 pa-0" style="display:flex">
                      <v-card-title class="primary--text pa-0 pt-3 pl-2">
                        <v-tooltip
                          v-if="outcomeVar && showTitleBar"
                          bottom
                          color="primary"
                        >
                          <template v-slot:activator="{ on: tooltip }">
                            <img
                              :src="
                                '/images/' +
                                  outcomeVar.category +
                                  '-icon-128.png'
                              "
                              :title="outcomeVar.category"
                              style="height:1.75em"
                              class="ma-1"
                              @error="missingDomainFallback"
                              v-on="{ ...tooltip }"
                            />
                          </template>
                          <span>{{ outcomeVar.category }}</span>
                        </v-tooltip>

                        <v-tooltip
                          v-if="outcomeVar && showTitleBar"
                          top
                          color="primary"
                        >
                          <template v-slot:activator="{ on: tooltip }">
                            <span v-on="{ ...tooltip }">
                              {{
                                outcomeVar.abbreviation === outcomeVar.label
                                  ? outcomeVar.abbreviation
                                  : outcomeVar.abbreviation +
                                    ' | ' +
                                    outcomeVar.label
                              }}
                            </span>
                          </template>
                          <span>{{ outcomeVar.description }}</span>
                        </v-tooltip>

                        <v-spacer />

                        <span class="pr-2">
                          <v-chip
                            v-for="(x, index) in [
                              '1',
                              '0.1',
                              '0.05',
                              '0.01',
                              '0.001',
                            ]"
                            :key="`vc-${index}`"
                            :color="
                              colors['pvals'][x + '-' + colorScheme]['color']
                            "
                            :style="'border: 2px solid black;'"
                            :class="
                              'px-2 mx-1 ' +
                                (colorScheme == 'brewer5' && x == '0.001'
                                  ? 'white--text'
                                  : '')
                            "
                            >p &lt; {{ x }}</v-chip
                          >
                        </span>

                        <v-spacer />

                        <v-btn
                          v-if="false"
                          small
                          class="primary mx-2"
                          @click="exportTableDialog = true"
                          ><v-icon left>mdi-download</v-icon>Export table</v-btn
                        >
                      </v-card-title>
                    </v-col>
                  </v-row>
                </v-container>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>

      <v-row :class="{ isFullSizeViewWidth: showFullPanelView }">
        <v-col cols="12" :class="{ isFullSizeViewWidth: showFullPanelView }">
          <div
            v-if="outcomeVar.data_category != 'Continuous'"
            column
            align-center
            justify-center
            fill-width
          >
            <v-subheader class="title primary--text text--lighten-3">
              No pairwise test currently available for categorical variables
            </v-subheader>
          </div>

          <div
            v-else-if="outcomeVar && cohorts.length > 2"
            :class="{ isFullSizeViewWidth: showFullPanelView }"
          >
            <v-data-table
              :headers="headers"
              :items="cohorts"
              class="elevation-1"
              hide-default-header
              hide-default-footer
              disable-pagination
              dense
            >
              <template v-slot:item="props">
                <tr>
                  <td
                    v-for="(c, c_index) in cohorts"
                    :key="c.id"
                    class="text-subtitle-1"
                    :style="
                      table_cell_style(
                        c,
                        props.item,
                        c_index,
                        c2ind[props.item.id]
                      )
                    "
                    align="center"
                    @mouseover="
                      if (c_index < c2ind[props.item.id]) {
                        highlight_cell(c, props.item);
                      }
                    "
                    @mouseleave="unhighlight_cells()"
                    @click="table_cell_click(c, props.item)"
                  >
                    <div
                      v-if="c_index == c2ind[props.item.id]"
                      :class="title_cell_class(c, props.item)"
                    >
                      {{ c.label.replace(/^\[O\]_/, '') }}
                    </div>

                    <v-tooltip
                      v-if="c_index < c2ind[props.item.id]"
                      bottom
                      color="primary"
                    >
                      <template v-slot:activator="{ on: tooltip }">
                        <div
                          :class="
                            'pa-2 py-3 ' + table_cell_class(c, props.item)
                          "
                          v-on="{ ...tooltip }"
                        >
                          {{ table_cell(c, props.item) }}
                        </div>
                      </template>
                      <span>{{
                        'Click to select ' +
                          c.label.replace(/^\[O\]_/, '') +
                          ' and ' +
                          props.item.label.replace(/^\[O\]_/, '')
                      }}</span>
                    </v-tooltip>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <div class="pa-2">
              p-Values from Tukey's HSD (honest significant difference) test
            </div>
          </div>

          <div
            v-else-if="cohorts.length < 3"
            column
            align-center
            justify-center
            fill-height
          >
            <v-subheader class="title primary--text text--lighten-3">
              Tukey HSD test requires at least 3 study groups.
            </v-subheader>
          </div>
          <div v-else column align-center justify-center fill-width>
            <v-subheader class="title primary--text text--lighten-3">
              <v-icon x-large color="primary lighten-3">arrow_left</v-icon
              >SELECT VARIABLE FROM ANALYTICS PANEL
            </v-subheader>
          </div>
        </v-col>
      </v-row>
    </div>
  </v-sheet>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import { state } from '@/store/modules/dataExplorer/types';
import { format } from 'd3-format';
import { colors } from '@/utils/colors';
import { missingDomainFallback } from '@/utils/helpers';

export default {
  components: {},
  props: {
    showTitleBar: {
      type: Boolean,
      required: false,
      default: true,
    },
    analysis: {
      type: Object,
      required: true,
      default: () => {},
    },
    cohorts: {
      type: Array,
      required: true,
      default: () => [],
    },
    visibleCohorts: {
      type: Array,
      required: true,
      default: () => [],
    },
    outcomeVar: {
      type: Object,
      default: null,
    },
    colorScheme: {
      type: String,
      required: false,
      default: 'val100',
    },
    showFullPanelView: {
      type: Boolean,
      required: false,
      default: false,
    },
    selectedAnalysisMode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      pairwiseTukeyHsdPvals: [],
      pval_dict: {},
      colors: colors,
      highlight_row: null,
      highlight_col: null,
      selected_row: null,
      selected_col: null,
      missingDomainFallback: missingDomainFallback,
    };
  },
  computed: {
    ...mapState('dataExplorer', {
      collection: state.COLLECTION,
      outcomeVariables: state.OUTCOME_VARIABLES,
      anova_pvals: state.ANOVA_PVALS,
      data: state.DATA,
    }),
    c2ind() {
      let c2i = {};
      let i = 0;
      this.cohorts.forEach(c => {
        c2i[c.id] = i++;
      });
      return c2i;
    },
    headers() {
      const headers = [];
      const cc = this.cohorts;
      cc.forEach(c => {
        headers.push({
          text: c.id,
          align: 'center',
          sortable: false,
          divider: true,
          value: c.label,
          class: 'text-subtitle-1 font-weight-bold',
        });
      });
      // remove last column
      //      headers.pop();
      return headers;
    },
  },
  watch: {
    outcomeVar() {
      this.update_pval_dict();
    },
    pairwiseTukeyHsdPvals() {
      this.update_pval_dict();
    },
    collection() {},
    data() {},
    async cohorts() {
      await this.analyze_cohorts();
    },
    visibleCohorts(vc) {
      let c2ind = this.c2ind;
      let vis_inds = vc.map(c => c2ind[c.id]).sort();
      let n_vis_inds = vis_inds.length;
      let sel_inds = [];
      if (this.selected_row) sel_inds.push(c2ind[this.selected_row.id]);
      if (this.selected_col) sel_inds.push(c2ind[this.selected_col.id]);
      sel_inds = sel_inds.sort();
      let n_sel_inds = sel_inds.length;
      // if 2 study groups are selected then highlight that cell, if not already doing so
      if (n_vis_inds == 2) {
        let already_selected =
          n_sel_inds == 2 &&
          vis_inds[0] == sel_inds[0] &&
          vis_inds[1] == sel_inds[1];
        if (!already_selected) {
          this.selected_row = vc[0];
          this.selected_col = vc[1];
        }
        return;
      }

      // otherwise reset current selection (b/c we only care about a selected pair in this component)
      this.selected_row = null;
      this.selected_col = null;
    },
  },
  async mounted() {
    await this.analyze_cohorts();
    this.update_pval_dict();
  },
  methods: {
    async analyze_cohorts() {
      let collection = this.collection;
      let cohorts = this.cohorts;
      let analysis = this.analysis;
      let data = this.data;

      // need cohorts, collection, and output vars
      if (
        typeof collection === 'undefined' ||
        typeof collection.observation_variables === 'undefined' ||
        typeof cohorts === 'undefined' ||
        typeof analysis == 'undefined'
      ) {
        this.pairwiseTukeyHsdPvals = [];
        return;
      }

      // create group of samples for each cohort:
      const groups = [];
      cohorts.forEach(c => {
        if (c.collection_id === collection.id) {
          const subjids = [];
          c.subject_ids.forEach(sid => {
            subjids[sid] = 1;
          });
          const cohortData = data.filter(d => d.subject_id in subjids);
          groups.push({ id: c.id, label: c.label, data: cohortData });
        }
      });
      const numGroups = groups.length;

      // need at least 3 groups for statsmodel Tukey HSD
      if (numGroups < 3) return;

      // pass _all_ observation variables, not just the selected ones
      const outputVariables = [];
      collection.observation_variables.forEach(v => {
        v.children.forEach(c => {
          outputVariables.push(c);
        });
      });
      if (this.selectedAnalysisMode == 'Outcome based') {
        collection.subject_variables.forEach(v => {
          if (v.children && v.children.length > 0) {
            v.children.forEach(c => {
              outputVariables.push(c);
            });
          } else {
            outputVariables.push(v);
          }
        });
      }
      let comparisonField = analysis.collection.is_longitudinal
        ? analysis.input.comparisonField
        : 'value';
      try {
        const { data } = await axios.post(`/api/compute-pairwise-tukeyhsd`, {
          numGroups,
          groups,
          outputVariables,
          comparisonField,
        });
        this.pairwiseTukeyHsdPvals = data.results;
      } catch ({ response }) {
        // response.data.error
      }
    },
    update_pval_dict() {
      const pd = {};
      if (!this.outcomeVar || typeof this.outcomeVar === 'undefined') return;
      if (this.cohorts.length < 3) return;
      if (!(this.outcomeVar.label in this.pairwiseTukeyHsdPvals)) {
        //        console.log(
        //          'TukeyHSDHeatmap: no results found for ' + this.outcomeVar.label
        //        );
        this.pval_dict = {};
        return;
      }
      const pvals = this.pairwiseTukeyHsdPvals[this.outcomeVar.label];
      const groups = pvals.unique_groups;
      const ng = groups.length;
      let ind = 0;
      for (let i = 0; i < ng; i += 1) {
        pd[groups[i]] = {};
        for (let j = i + 1; j < ng; j += 1) {
          pd[groups[i]][groups[j]] =
            pvals == null || pvals.pvals == null || pvals.pvals[ind] == null
              ? 'x'
              : pvals.pvals[ind];
          ind += 1;
        }
      }
      this.pval_dict = pd;
    },
    table_cell(cohort1, cohort2) {
      const pd = this.pval_dict;
      let pval = null;
      if (cohort1.id in pd && cohort2.id in pd[cohort1.id]) {
        pval = pd[cohort1.id][cohort2.id];
      } else if (cohort2.id in pd && cohort1.id in pd[cohort2.id]) {
        pval = pd[cohort2.id][cohort1.id];
      } else {
        return 'loading...';
      }
      if (pval < 0.001) {
        return 'p<0.001';
      }
      return `p=${format('.3f')(pval)}`;
    },
    table_cell_aux(cohort1, cohort2, which) {
      const pd = this.pval_dict;
      let pval = null;
      if (cohort1.id in pd && cohort2.id in pd[cohort1.id]) {
        pval = pd[cohort1.id][cohort2.id];
      } else if (cohort2.id in pd && cohort1.id in pd[cohort2.id]) {
        pval = pd[cohort2.id][cohort1.id];
      }

      if (pval == null) return which == 'color' ? '#FFFFFF' : '';
      let ccl = this.colors['pvals']['1' + '-' + this.colorScheme][which];
      if (pval < 0.001) {
        ccl = this.colors['pvals']['0.001' + '-' + this.colorScheme][which];
      } else if (pval < 0.01) {
        ccl = this.colors['pvals']['0.01' + '-' + this.colorScheme][which];
      } else if (pval < 0.05) {
        ccl = this.colors['pvals']['0.05' + '-' + this.colorScheme][which];
      } else if (pval < 0.1) {
        ccl = this.colors['pvals']['0.1' + '-' + this.colorScheme][which];
      }

      return ccl;
    },
    table_cell_color(cohort1, cohort2) {
      return this.table_cell_aux(cohort1, cohort2, 'color');
    },
    table_cell_class(cohort1, cohort2) {
      return this.table_cell_aux(cohort1, cohort2, 'class');
    },
    table_text_color(cohort1, cohort2) {
      const pd = this.pval_dict;
      let pval = null;
      if (cohort1.id in pd && cohort2.id in pd[cohort1.id]) {
        pval = pd[cohort1.id][cohort2.id];
      } else if (cohort2.id in pd && cohort1.id in pd[cohort2.id]) {
        pval = pd[cohort2.id][cohort1.id];
      }

      if (pval != null) {
        if (this.colorScheme == 'brewer5') {
          if (pval < 0.001) {
            return 'white';
          }
        }
      }
      return 'black';
    },
    table_cell_style(cohort1, cohort2, i1, i2) {
      var style = {};
      style['color'] = this.table_text_color(cohort1, cohort2);
      // selected cell
      if (cohort1 == this.selected_row && cohort2 == this.selected_col) {
        style['border'] = '2px solid rgb(236, 177, 212)';
      }
      // highlighted cell due to mouseover
      else if (cohort1 == this.highlight_row && cohort2 == this.highlight_col) {
        style['border'] = '2px solid blue';
      }
      // default appearance
      else {
        if (i1 == i2) {
          style['padding'] = '1px';
          style['border'] = '1px solid white';
          style['border-left'] = '1px solid rgba(0,0,0,0.12)';
        } else if (i1 < i2) {
          style['padding'] = '1px';
          style['border'] = '1px solid rgba(0,0,0,0.12)';
        } else {
          style['border'] = '2px solid white';
        }
      }
      return style;
    },
    highlight_cell(c1, c2) {
      this.highlight_row = c1;
      this.highlight_col = c2;
    },
    unhighlight_cells() {
      this.highlight_row = null;
      this.highlight_col = null;
    },
    title_cell_class(c1, c2) {
      var cls = 'font-weight-medium pa-2 py-3';
      if (this.highlight_row == c1 || this.highlight_col == c2) {
        cls = cls + ' accent white--text';
      } else if (this.selected_row == c1 || this.selected_col == c2) {
        cls = cls + ' hcolor';
      }
      return cls;
    },
    table_cell_click(cohort1, cohort2) {
      let c2ind = this.c2ind;
      if (c2ind[cohort1.id] < c2ind[cohort2.id]) {
        this.selected_row = cohort1;
        this.selected_col = cohort2;
        this.$emit('selectedCohorts', [cohort1, cohort2]);
      }
    },
    get_td_style(i1, i2) {
      if (i1 == i2) {
        return 'border-left: 1px solid rgba(0,0,0,0.12);';
      } else if (i1 < i2) {
        return 'border: 1px solid rgba(0,0,0,0.12);';
      } else {
        return 'border: none;';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
tbody {
  tr:hover {
    background-color: transparent !important;
  }
}

.hcolor {
  background-color: rgb(236, 177, 212);
}

.isFullSizeViewWidth {
  width: fit-content;
}

.isFullSizeViewOverflow {
  overflow: auto;
}
</style>
